module.exports = __webpack_public_path__ + "img/new.027125ec.jpg";